import cx from 'classnames';
import React from 'react';
import { SideNavItem } from './side-nav-item.js';
export const SideNavItemGroup = ({ items, alwaysExpanded, className, ...rest }) => {
    if (!items || !items.length) {
        return null;
    }
    return (React.createElement("div", { className: cx('tds-sidenav-group', {
            'tds-sidenav-group--always-expanded': alwaysExpanded,
        }, className), ...rest },
        React.createElement("ol", { className: "tds-site-nav-items tds-site-nav-items--vertical" }, items.map((item, i) => {
            var _a;
            return (React.createElement("li", { key: (_a = item.id) !== null && _a !== void 0 ? _a : i },
                React.createElement(SideNavItem, { ...item })));
        }))));
};
